// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-3f040cbb],\n.fade-leave-active[data-v-3f040cbb] {\n  -webkit-transition: 0.2s;\n  transition: 0.2s;\n}\n.fade-enter[data-v-3f040cbb],\n.fade-leave-to[data-v-3f040cbb] {\n  opacity: 0;\n}\n[dir] .fade-enter[data-v-3f040cbb], [dir] .fade-leave-to[data-v-3f040cbb] {\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n}\n.input-size[data-v-3f040cbb] {\n  font-size: 1.4rem;\n}", ""]);
// Exports
module.exports = exports;
